/* Preferences menu bar / dropdown */
import { useState, useContext, useEffect } from 'react';
import { useLocation, Link } from 'react-router-dom'; 
import { LanguageContext } from '../contexts/LanguageContext';
//import { ThemeContext } from '../contexts/ThemeContext';
/*import { StepContext } from '../contexts/StepContext';*/
import ProgressBar from './ProgressBar';
import Axios from 'axios';
import url from '../constants/urlsPaths';
import { FormattedMessage } from 'react-intl';
import messages from '../lang/preferences';
import ppeLogo from '../ressources/logo-sq-green.svg';

import './Preferences.css';

export default function Preferences({ questions, user, auth }) {
    const { locale, selectLanguage } = useContext(LanguageContext);
    // Get attitudes value IDs from environment variable
    const envAttitudesIds = (process.env.REACT_APP_ATTITUDES_VALUE_IDS || '').split(',').map(s => s.trim()).filter(Boolean);
    //const { themeValue, setThemeValue } = useContext(ThemeContext);
    const [open, setOpen] = useState(false);
    /* const { setStep } = useContext(StepContext); */
    let location = useLocation();
    const [showAttitudesForUser, setShowAttitudesForUser] = useState(false);

    const changeLanguage = (lang) => {
        //sessionStorage.setItem('language', lang); // Set storage first
        selectLanguage(lang); // Then update context
        closePreferences();
        console.log("Language changed to:", lang,"page will reload");
        if (window.location.pathname.includes('/edit')) {
        window.location.reload();
        }
    }

    /* Theme toggling removed: ThemeContext not currently used in this component. */
    function handleLogoClick(e) {
        const logo = e.currentTarget;
        logo.classList.toggle("logo-rotate");
    }

    function handleLogoTouch(e) {
        const logo = e.currentTarget;
        logo.classList.add("logo-rotate");
    }
    /*
    const changeStep = () => {
        sessionStorage.setItem('step', 0);
        setStep(0);
    }*/
    const redirectToManager = () => { 
        window.location.href = "/manager";
    }

    const redirectToHome = () => {
        if(location.pathname.includes('ScopePDFReport')){
            window.location.href = "/key/intro";
        }
        else {
            window.location.href = "/";
        }
    }



    const redirectToBlog = () => {
        window.location.href = "/blog";
    }

   const closePreferences = () => {
    setOpen(o => !o);
    console.log("Preferences menu toggled:", !open);
};

    // Decide whether to show Attitudes link for the current user (when viewing a userInfo page)
    // Logic: prefer an explicit `companyValues`/`values` field on the location.state user object.
    // Fallback: fetch companies and check company's `values` array for the TARGET_VALUE_ID.
    useEffect(() => {
        let mounted = true;
        async function check() {
            const TARGET_VALUE_IDS = envAttitudesIds;
            try {
                let currentUser = user || location.state || null;
                // Fallback: fetch user from backend if not present
                if (!currentUser) {
                    // Try to get user key or code from URL
                    const pathMatch = window.location.pathname.match(/([A-Za-z0-9]{10,})/);
                    const userKey = pathMatch ? pathMatch[1] : null;
                    const userCode = sessionStorage.getItem('code') || null;
                    if (userKey || userCode) {
                        try {
                            const token = (() => {
                                const t = sessionStorage.getItem('token');
                                if (!t || t === 'null' || t === 'undefined') return null;
                                try { return JSON.parse(t); } catch (e) { return null; }
                            })();
                            const res = await Axios.post(url.getUser, { key: userKey, code: userCode }, { headers: { 'x-access-token': token } });
                            if (res.data && typeof res.data === 'object') {
                                currentUser = res.data;
                                console.log('Fetched user from backend:', currentUser);
                            }
                        } catch (e) {
                            console.warn('Failed to fetch user fallback:', e);
                        }
                    }
                }
                console.log('user:', currentUser);
                // Check direct user-provided company values
                const userValues = currentUser && (currentUser.companyValues || currentUser.company_values || currentUser.values || currentUser.companyValuesIds);
                console.log('TARGET_VALUE_IDS:', TARGET_VALUE_IDS);
                console.log('userValues:', userValues);
                if (Array.isArray(userValues)) {
                    if (mounted) setShowAttitudesForUser(userValues.some(v => TARGET_VALUE_IDS.includes(v)));
                    return;
                }

                // Defensive: ensure userCompanyField is not undefined
                const userCompanyField = currentUser && typeof currentUser.company !== 'undefined' ? currentUser.company : null;
                console.log('userCompanyField:', userCompanyField);
                if (Array.isArray(userCompanyField)) {
                    if (mounted) setShowAttitudesForUser(userCompanyField.some(v => TARGET_VALUE_IDS.includes(v)));
                    return;
                }
                if (typeof userCompanyField === 'string') {
                    if (mounted) setShowAttitudesForUser(TARGET_VALUE_IDS.includes(userCompanyField));
                    return;
                }

                // If we have company ids on the user, fetch companies and check their values arrays
                const userCompanyIds = currentUser && currentUser.company ? (Array.isArray(currentUser.company) ? currentUser.company : [currentUser.company]) : [];
                if (userCompanyIds.length === 0) {
                    if (mounted) setShowAttitudesForUser(false);
                    return;
                }

                // Call backend to get companies (uses same endpoint as Admin)
                const token = (() => {
                    const t = sessionStorage.getItem('token');
                    if (!t || t === 'null' || t === 'undefined') return null;
                    try { return JSON.parse(t); } catch (e) { return null; }
                })();
                const code = sessionStorage.getItem('code');
                const res = await Axios.post(url.getCompanies, { code }, { headers: { 'x-access-token': token } });
                const comps = Array.isArray(res.data) ? res.data : [];
                const match = comps.some(c => {
                    if (!c) return false;
                    const vals = c.values || c.companyValues || c.company_values || [];
                    return userCompanyIds.includes(c._id) && Array.isArray(vals) && vals.some(v => TARGET_VALUE_IDS.includes(v));
                });
                if (mounted) setShowAttitudesForUser(!!match);
            } catch (e) {
                console.warn('Failed to check company values for Attitudes link', e);
                if (mounted) setShowAttitudesForUser(false);
            }
        }
        if (location.pathname.includes('userInfo') || location.pathname.includes('ScopePDFReport')) check();
        return () => { mounted = false; };
    }, [location.pathname, location.state, envAttitudesIds, user]);

    return (
            <div>
                <div className='Preferences-menu-box'>
                <svg version="1.1" className={`Preferences-menu${(location.pathname.includes('userInfo') || location.pathname.includes('ScopePDFReport')) && !open ? ' white-menu' : ''}${open ? ' open' : ''}`} xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20px" height="20px" viewBox="0 0 124 124" onClick={() => closePreferences()}>
                    <g>
                        <path d="M112,6H12C5.4,6,0,11.4,0,18s5.4,12,12,12h100c6.6,0,12-5.4,12-12S118.6,6,112,6z" />
                        <path d="M112,50H12C5.4,50,0,55.4,0,62c0,6.6,5.4,12,12,12h100c6.6,0,12-5.4,12-12C124,55.4,118.6,50,112,50z" />
                        <path d="M112,94H12c-6.6,0-12,5.4-12,12s5.4,12,12,12h100c6.6,0,12-5.4,12-12S118.6,94,112,94z" />
                    </g>
                </svg>
                </div>
                <div>
                        <div id="Preferences" className={open ? 'open' : ''}>
                            <div id="Preferences-content">
                                {/*<button onClick={changeStep}>Remettre à zéro</button>*/}

                                {
                                    questions ? <><h2><FormattedMessage {...messages.MENUPROGRESSION} /></h2><ProgressBar questions={questions} /></> : null
                                }
                                <h2><FormattedMessage {...messages.MENUCHANGERLANGUE} /></h2>
                                <div className="Preferences-languages">
                                    <span onClick={() => changeLanguage("fr")} className={ locale === "fr" ? "lang-option-selected" : "lang-option" }>🇫🇷 Français</span>
                                    <span onClick={() => changeLanguage("de")} className={ locale === "de" ? "lang-option-selected" : "lang-option" }>🇩🇪 Deutsch</span>
                                    <span onClick={() => changeLanguage("en")} className={ locale === "en" ? "lang-option-selected" : "lang-option" }>🇬🇧 English</span>
                                    <span onClick={() => changeLanguage("it")} className={ locale === "it" ? "lang-option-selected" : "lang-option" }>🇮🇹 Italiano</span>
                                    <span onClick={() => changeLanguage("es")} className={ locale === "es" ? "lang-option-selected" : "lang-option" }>🇪🇸 Español</span>
                                    <span onClick={() => changeLanguage("ja")} className={ locale === "ja" ? "lang-option-selected" : "lang-option" }>🇯🇵 日本語</span>
                                    <span onClick={() => changeLanguage("zh")} className={ locale === "zh" ? "lang-option-selected" : "lang-option" }>🇨🇳 简体中文</span>
                                    <span onClick={() => changeLanguage("zh-TW")} className={ locale === "zh-TW" ? "lang-option-selected" : "lang-option" }>🇹🇼 繁體中文</span>
                                </div>
                                {
                                    !location.search && !questions && location.pathname === '/' && !sessionStorage.getItem('token') && (
                                        <h2 onClick={() => redirectToBlog()} style={{ cursor: 'pointer', marginBottom: '15px' }}>Blog</h2>
                                    )
                                }
                                    {/*
                                        <svg onClick={() => changeTheme()} title="Icon made by flaticon" version="1.1" id="Preferences-night" xmlns="http://www.w3.org/2000/svg"  x="0px" y="0px" width="20px" height="20px" viewBox="0 0 168.29 168.29" fill={themeValue === "day" ? "black" : "#8084e0"}>
                                            <path d="M159.81,127.909c-1.025-2.473-3.289-4.212-5.942-4.565c-24.423-3.241-45.44-19.364-54.848-42.078 c-9.409-22.715-5.95-48.978,9.028-68.539c1.628-2.125,1.999-4.957,0.975-7.43c-1.024-2.473-3.289-4.212-5.942-4.565 C99.416,0.247,95.69,0,92.005,0C80.957,0,70.152,2.155,59.889,6.406c-20.764,8.601-36.935,24.772-45.533,45.536 c-8.597,20.761-8.595,43.628,0.004,64.39c13.074,31.563,43.595,51.957,77.756,51.957c0.001,0,0.001,0,0.001,0 c11.051,0,21.872-2.161,32.164-6.424c13.644-5.652,25.592-14.825,34.553-26.528C160.462,133.213,160.834,130.382,159.81,127.909z M118.541,148.008c-8.463,3.505-17.353,5.283-26.424,5.282c-28.073,0-53.155-16.76-63.899-42.698 c-7.067-17.061-7.068-35.852-0.004-52.911C35.28,40.62,48.567,27.332,65.629,20.265c7.424-3.075,15.189-4.816,23.126-5.188 c-11.761,22.021-13.291,48.521-3.595,71.93c9.694,23.405,29.509,41.059,53.392,48.315 C132.687,140.647,125.916,144.953,118.541,148.008z"/>
                                        </svg>*/
                                    }
                               {/* <br></br>
                                <div><span onClick={() => changeTheme()}>Toggle theme</span></div>
                                
                                */} 
                                {
                                    !questions && location.pathname === '/' && <div className="manager-link"><div onClick={() => redirectToManager()}>Manager Portal</div></div>
                                }
                                {
                                    !questions && (
                                        (
                                            location.pathname.includes('userInfo') &&
                                            !location.pathname.includes('userInfoAndAttitudes') &&
                                            showAttitudesForUser && location.state
                                        ) || (
                                            location.pathname.includes('ScopePDFReport') &&
                                            showAttitudesForUser && user
                                        )
                                    ) && (
                                        <Link to={{ pathname: '/userInfoAndAttitudes', state: { ...(user || location.state), auth } }} className="manager-link">Attitudes</Link>
                                    )
                                }

                                {
                                    !questions && location.pathname.includes('userInfoAndAttitudes') && showAttitudesForUser && location.state && (
                                        <Link to={{ pathname: '/userInfo', state: location.state }} className="manager-link">SCOPE Report</Link>
                                    )
                                }
                                {
                                    !questions && location.pathname !== '/' && !location.pathname.includes('/key/') && !showAttitudesForUser && !(location.state && location.state.email === '') && <div className="manager-link"><div onClick={() => redirectToHome()}>Home</div></div>
                                }
                                <br></br>
                            </div>
                        </div>
                    </div>
                <div className="menu-bar">
                    <img alt='ppe-logo' className="login-logo" src={ppeLogo} onTouchStart={handleLogoTouch} onClick={handleLogoClick}></img> 
                    <h2 className="Graphs-title login-page">SCOPE</h2>          
                </div>
            </div>
    )
}
